import { useSelector } from 'react-redux';

import { EBackgrounds, IHeroBannerProps } from '../../../components/HeroBanner';
import { selectIsCalculatorPage } from '../../../selectors/page';
import { IApplicationState } from '../../../types/redux';

export const useBannerName = (): IHeroBannerProps['backgroundFor'] => {
  const subdomain = useSelector((state: IApplicationState) => state.page.subdomain);
  const isCalculatorPage = useSelector(selectIsCalculatorPage);

  if (!isCalculatorPage) {
    return EBackgrounds.agent;
  }

  if (EBackgrounds[subdomain as EBackgrounds]) {
    return EBackgrounds[subdomain as EBackgrounds];
  }

  return EBackgrounds.default;
};
